module.exports = __webpack_public_path__ + "static/media/wheeled-BG-2nd-layer-two@3x.34787bee.png";